import React, {Component} from 'react';
import {Range, getTrackBackground} from 'react-range';
import {kNIntoTons, kNIntoTonsRound, RoundTo1Decimal, tonsTokN} from '../utils';
import InputWithRangeIntegration
  from './InputWithRangeIntegration/InputWithRangeIntegration';

const rangeValues = Object.freeze ({
  MIN: 'min',
  MAX: 'max',
});

export default class ControlPanel extends Component {
  constructor (props) {
    super (props);

    this.state = {
      minValue: 0,
      maxValue: 0,
      isExceededClassName: '',
    };

    this.handleValueChangeInkN = this.handleValueChangeInkN.bind (this);
    this.handleValueChangeInTons = this.handleValueChangeInTons.bind (this);
    this.handleValuesChangeOnSlider = this.handleValuesChangeOnSlider.bind (
      this
    );
    this.handleSpliceChange = this.handleSpliceChange.bind (this);
    this.validateValue = this.validateValue.bind (this);
    this.setExceededRangeClass = this.setExceededRangeClass.bind (this);
    this.sdmbl = props.sdmbl;
    this.showSdmbl = props.showSdmbl;
  }

  showTDBF = () => {
    return this.props.sdmbl.visible === 'TRUE' && parseFloat(this.props.sdmbl.min) > 1  && parseFloat(this.props.sdmbl.max) > parseFloat(this.props.sdmbl.min);
  }

  sdmblRange () {
    return {
      min: Math.round(this.props.sdmbl.min * 100),
      max: Math.round(this.props.sdmbl.max * 100),
    }
  }

  getEdgeValues = () => {
    const { edgeValues, rangeType } = this.props;
    if (this.showTDBF() && rangeType === 'sdmbl') {
      return {
        min: edgeValues.min / parseFloat(this.props.sdmbl.min),
        max: edgeValues.max,
      };
    }
    return edgeValues;
  }

  handleValueChangeInTons (value, rangeValueType) {
    this.handleValueChangeInkN (tonsTokN (value), rangeValueType);
  }

  handleValueChangeInkN (value, rangeValueType) {
    if (
      Math.round (value).toString ().length >
      this.props.edgeValues.max.toString ().length
    ) {
      return false;
    }
    if (rangeValueType === rangeValues.MAX) {
      this.props.handleRangeChange (
        this.props.minRangeValueInkN,
        RoundTo1Decimal (value)
      );
      this.setExceededRangeClass (
        value,
        'range-slider--max-value-is-exceeded-min',
        'range-slider--max-value-is-exceeded-max'
      );
    } else {
      this.props.handleRangeChange (
        RoundTo1Decimal (value),
        this.props.maxRangeValueInkN
      );
      this.setExceededRangeClass (
        value,
        'range-slider--min-value-is-exceeded-min',
        'range-slider--min-value-is-exceeded-max'
      );
    }
  }

  handleValuesChangeOnSlider (values) {
    this.setState ({
      ...this.state,
      isExceededClassName: '',
    });

    const showSdmblThumb = this.props.sdmbl.min !== 1.0 && this.props.rangeType === 'sdmbl';
    const minVal = values[0];
    const maxVal = showSdmblThumb ? values[2] : values[1];

    this.props.handleRangeChange (minVal, maxVal);
  }

  validateValue () {
    this.props.validateValue (
      this.props.minRangeValueInkN,
      this.props.maxRangeValueInkN
    );
    this.setState ({
      ...this.state,
      isExceededClassName: '',
    });
  }

  setExceededRangeClass (
    value,
    classNameForMinExceeded,
    classNameForMaxExceeded
  ) {
    const edgeValues = this.getEdgeValues();
    if (value < edgeValues.min) {
      this.setState ({
        ...this.state,
        isExceededClassName: classNameForMinExceeded,
      });
    } else if (value > edgeValues.max) {
      this.setState ({
        ...this.state,
        isExceededClassName: classNameForMaxExceeded,
      });
    } else {
      this.setState ({
        ...this.state,
        isExceededClassName: '',
      });
    }
  }

  handleSpliceChange (event) {
    this.props.handleSpliceChange (event.target.value);
  }

  render () {
    const {
      isMBL,
      minRangeValueInkN,
      maxRangeValueInkN,
      rangeType,
      showStrengthTypes,
    } = this.props;

    const edgeValues = this.getEdgeValues();

    const sdmblMinValue = parseFloat(this.props.sdmbl.min);
    const sdmblThumbValue = Math.min(minRangeValueInkN * sdmblMinValue, edgeValues.max);
    const showSdmblThumb = sdmblMinValue !== 1.0 && rangeType === 'sdmbl';

    const sliderValues = showSdmblThumb
      ? [Math.max(minRangeValueInkN, edgeValues.min), sdmblThumbValue, Math.min(maxRangeValueInkN, edgeValues.max)]
      : [Math.max(minRangeValueInkN, edgeValues.min), Math.min(maxRangeValueInkN, edgeValues.max)];

    const rangeColors = showSdmblThumb
      ? ['#d1dde1', '#d1dde1', '#29588C', '#d1dde1']
      : ['#d1dde1', '#29588C', '#d1dde1'];

    return (
      <div className="ordering-filter print-hidden">

        <form>
          <fieldset>
            <legend className="ordering-filter__title ordering-filter__title--no-margin">
              Product selection
            </legend>
            <p>Rope strength {!isMBL && 'range'} filter</p>
            <div className="ordering-filter__section">
              <div className="range">
                <div className="range__input-wrapper">
                  <div className="range__current-value-wrapper">
                    <InputWithRangeIntegration
                      handleRangeChange={event =>
                        this.handleValueChangeInkN (
                          event.target.value,
                          rangeValues.MIN
                        )}
                      name="minValueInkN"
                      value={minRangeValueInkN}
                      valueToDisplay={Math.round(minRangeValueInkN)}
                      minValue={edgeValues.min}
                      maxValue={edgeValues.max}
                      validateValue={this.validateValue}
                      inputLabel={`Minimum value of ${isMBL ? 'minimum breaking load' : 'line design break force'} in kN`}
                      id="minValueInkN"
                      label="kN"
                      step="1"
                    />
                  </div>
                  {showSdmblThumb &&
                  <div className="range__max">
                    <InputWithRangeIntegration
                      name="sdmblValueInkN"
                      value={sdmblThumbValue}
                      valueToDisplay={Math.round(sdmblThumbValue)}
                      minValue={edgeValues.min}
                      maxValue={edgeValues.max}                      
                      inputLabel={`SDMBL value in kN`}
                      id="sdmblValueInkN"
                      label="kN"
                      step="1"
                      disabled={true}
                    />
                  </div>
                  }
                  <div className="range__max">
                    <InputWithRangeIntegration
                      handleRangeChange={event =>
                        this.handleValueChangeInkN (
                          event.target.value,
                          rangeValues.MAX
                        )}
                      name="maxValueInkN"
                      value={maxRangeValueInkN}
                      valueToDisplay={Math.round (maxRangeValueInkN)}
                      minValue={edgeValues.min}
                      maxValue={edgeValues.max}
                      validateValue={this.validateValue}
                      inputLabel={`Maximum value of ${isMBL ? 'minimum breaking load' : 'line design break force'} in kN`}
                      id="maxValueInkN"
                      label="kN"
                      step="1"
                      disabled={rangeType === 'sdmbl'}
                    />
                  </div>
                </div>
                <div
                  className={'range-slider ' + this.state.isExceededClassName}
                >
                  <Range
                    step={1}
                    min={edgeValues.min}
                    max={edgeValues.max}
                    ref={this.range}
                    values={sliderValues}
                    onChange={values =>
                      this.handleValuesChangeOnSlider (values)}
                    renderTrack={({props, children}) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          background: getTrackBackground ({
                            values: sliderValues,
                            colors: rangeColors,
                            min: edgeValues.min,
                            max: edgeValues.max,
                          }),
                        }}
                        className="range-slider__track"
                      >
                        {children}
                      </div>
                    )}
                    renderThumb={({props, index}) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          zIndex: index === 0 && rangeType === 'sdmbl'
                            ? 1
                            : undefined,
                        }}
                        className={
                          'range-slider__thumb ' +
                            (index === 0
                              ? 'range-slider__thumb--min'
                              : (index === 1 && showSdmblThumb
                                  ? 'range-slider__thumb--sdmbl disabled'
                                  : 'range-slider__thumb--max')) +
                            (index === (showSdmblThumb ? 2 : 1) &&
                            rangeType === 'sdmbl'
                              ? ' disabled'
                              : '')
                        }
                      />
                    )}
                  />

                </div>
                <div className="range__input-wrapper">
                  <div className="range__current-value-wrapper">
                    <InputWithRangeIntegration
                      name="minValueInTons"
                      handleRangeChange={event =>
                        this.handleValueChangeInTons (
                          event.target.value,
                          rangeValues.MIN
                        )}
                      value={kNIntoTons(minRangeValueInkN)}
                      valueToDisplay={RoundTo1Decimal(
                        kNIntoTons(minRangeValueInkN)
                      )}
                      minValue={kNIntoTonsRound (edgeValues.min)}
                      maxValue={kNIntoTonsRound (edgeValues.max)}
                      validateValue={this.validateValue}
                      id="minValueInTons"
                      label="metric tons"
                      inputLabel={`Minimum value of ${isMBL ? 'minimum breaking load' : 'line design break force'} metric tons`}
                      step="0.1"
                    />
                  </div>
                  {showSdmblThumb &&
                  <div className="range__max">
                    <InputWithRangeIntegration
                      name="sdmblValueInTons"
                      value={kNIntoTons(sdmblThumbValue)}
                      valueToDisplay={RoundTo1Decimal(
                        kNIntoTons(sdmblThumbValue)
                      )}
                      minValue={kNIntoTonsRound(edgeValues.min)}
                      maxValue={kNIntoTonsRound(edgeValues.max)}                   
                      inputLabel={`SDMBL value in metric tons`}
                      id="sdmblValueInTons"
                      label="metric tons"
                      step="0.1"
                      disabled={true}
                    />
                  </div>
                  }
                  <div className="range__max">
                    <InputWithRangeIntegration
                      handleRangeChange={event =>
                        this.handleValueChangeInTons (
                          event.target.value,
                          rangeValues.MAX
                        )}
                      name="maxValueInTons"
                      value={kNIntoTons (maxRangeValueInkN)}
                      valueToDisplay={RoundTo1Decimal (
                        kNIntoTons (maxRangeValueInkN)
                      )}
                      minValue={kNIntoTonsRound (edgeValues.min)}
                      maxValue={kNIntoTonsRound (edgeValues.max)}
                      validateValue={this.validateValue}
                      inputLabel={`Maximum value of ${isMBL ? 'minimum breaking load' : 'line design break force'} metric tons`}
                      id="maxValueInTons"
                      label="metric tons"
                      step="0.1"
                      disabled={rangeType === 'sdmbl'}
                    />
                  </div>
                </div>

              </div>
            </div>
          </fieldset>
          {showStrengthTypes && <fieldset>
            <legend className="ordering-filter__title">
              Rope strength type
            </legend>
            <div className="styled-radio-button">
              <input
                type="radio"
                name="rangeType"
                id="spliced_true"
                value="spliced"
                onChange={this.handleSpliceChange}
                checked={rangeType === 'spliced'}
              />
              <label htmlFor="spliced_true">{this.showTDBF() ? 'TDBF' : 'LDBF'} / MBL spliced</label>
            </div>
            {this.showSdmbl && 
              <div className="styled-radio-button">
                <input
                  type="radio"
                  name="rangeType"
                  id="sdmbl"
                  value="sdmbl"
                  onChange={this.handleSpliceChange}
                  checked={rangeType === 'sdmbl'}
                />
                <label htmlFor="sdmbl">SDMBL ({this.sdmblRange().min}-{this.sdmblRange().max}%)</label>
              </div>
              } 
            <div className="styled-radio-button">
              <input
                type="radio"
                name="rangeType"
                id="spliced_false"
                value="unspliced"
                onChange={this.handleSpliceChange}
                checked={rangeType === 'unspliced'}
              />
              <label htmlFor="spliced_false">
                MBL unspliced {!isMBL && '*'}
              </label>
            </div>
            {!isMBL &&
              <p className="u-bottom-margin--none">
                * Unspliced strength is filtered on 10% higher than the {this.showTDBF() ? 'TDBF' : 'LDBF'} strength
              </p>}
          </fieldset>}
        </form>
      </div>
    );
  }
}
